import API_ENDPOINTS from '../constants/api_endpoints';
import { realBricksApi } from './api.service';

export const getAmenitiesService = (
  page,
  limit,
  sortField,
  sortType,
  search
) => {
  let queryString = '';

  return realBricksApi.get(
    `${API_ENDPOINTS.AMENITY.AddAmenity}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}${queryString}`,
    {
      params: {
        ...(search && { search }),
      },
    }
  );
};

export const addAmenityService = (body) => {
  return realBricksApi.post(API_ENDPOINTS.AMENITY.AddAmenity, body);
};

export const getAmenityByIDService = (id) => {
  return realBricksApi.get(`${API_ENDPOINTS.AMENITY.AddAmenity}/${id}`);
};

export const updateAmenityService = (id, body) => {
  return realBricksApi.patch(`${API_ENDPOINTS.AMENITY.AddAmenity}/${id}`, body);
};

export const deleteAmenityService = (id) => {
  return realBricksApi.delete(`${API_ENDPOINTS.AMENITY.AddAmenity}/${id}`);
};
